<template>
  <!-- eslint-disable vue/max-attributes-per-line -->
  <div class="legal-page p-t-large" data-test="page-freetrial">
    <div class="container large t-c">
      <div class="m-t-3 m-b-0 t-l">
        <h2 class="m-b-3 page-title font-normal t-c">Free Trial Terms & Conditions</h2>
        <div class="m-b-2">
          <p class="m-0">Last Updated: April 23, 2019</p>
        </div>

        <div class="table-content">
          <p>
            By signing up for a free trial offer (“Trial Offer”), you are agreeing to these Free Trial Offer Terms & Conditions. The Trial Offer will give you free access to Luminary Premium for the trial period specified when you sign up. You will be charged if you do not cancel before the end of the trial period.
          </p>
          <p>You can cancel anytime.  If you purchased your trial directly from Luminary and you do not cancel before the end of the trial period, you authorize us to automatically charge your payment method on file for the applicable subscription price on a continuous monthly
          basis for so long as you remain a subscriber. You can cancel your Luminary Premium subscription anytime <a color="primary" target="_blank" href="/account/subscription">here</a>. Attempts to cancel by any other means will not be implemented. No partial refunds.</p>
          <p>If you purchased your trial through a third party, such as the Apple App Store or Google Play Store, you will be subject to that third party’s terms and conditions, and you must cancel through such third party.</p>
          <p>This offer is limited to new Luminary Premium subscribers and can only be used once per person. This offer may not be combinable with other offers. We reserve the right to change or cancel this offer at any time in our sole discretion. Void where prohibited. Offer not available for residents of Quebec.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMixin from '../shared/pageMixin';

export default {
  name: 'TermsFreeTrial',
  mixins: [pageMixin],
  data() {
    return {
      pageName: 'Free Trial Terms & Conditions',
    };
  },
};
</script>



// WEBPACK FOOTER //
// app/src/pages/TermsFreeTrial.vue